import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { browserHistory } from 'react-router';

import UpdateUser from '../UpdateUser';
import Spinner from '../../../../../../components/Spinner';
import Form from '../../../../../../components/Form/Form/';

import './Wrapper.scss';

const UpdateUserMutation = gql`
mutation (
  $first_name: String
  $last_name: String
  $password: String
) {
  updateUser(input: {
    first_name: $first_name
    last_name: $last_name
    password: $password
  }) {
    id
    first_name
    last_name
    email
  }
}
`;

const createCompanyMutation = gql`
mutation($Name: String!) {
  createHiringCompany(input: {
    name: $Name
  }) {
    id
    name
  }
}
`;

class Wrapper extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      UserCurrentValues: {},
      CompanyCurrentValues: {},
      error: null,
      loading: false,
    };

    this.handleUserChange = this.handleUserChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.displayUserForm = this.displayUserForm.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
  }

  componentDidMount () {
    if (this.props.authenticatedID === null) {
      browserHistory.push('/company');
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.authenticatedID === null) {
      browserHistory.push('/company');
    }
  }

  handleCompanyChange (event) {
    this.setState({
      CompanyCurrentValues: event.target.value,
      error: null,
    });
  }

  handleUserChange (event) {
    this.setState({
      UserCurrentValues: event.target.value,
      error: null,
    });
  }

  handleOnKey (event) {
    switch (event.keyCode) {
      case 13: // Enter
        event.preventDefault();
        this.handleRegister();
        break;
    }
  }

  validateForm (form) {
    const required = name => (Object.prototype.hasOwnProperty.call(form, name) && form[name] !== '');

    if (this.displayUserForm()) { // If form is present validate
      const requiredFields = ['first_name', 'last_name', 'password'];
      const prettyFields = ['First name', 'Last name', 'Password'];

      const errors = requiredFields.map(
        (field, index) => required(field) ? null : prettyFields[index]
      ).filter(x => x !== null);

      if (errors.length > 0) { // Has errors
        this.setState({
          error: (errors.join(' & ') + ' ' + ((errors.length > 1) ? 'are' : 'is') + ' required'),
        });
        return false;
      }
    }

    return true;
  }

  handleRegister () {
    if (this.validateForm(this.state.UserCurrentValues)) {
      const CompanyValues = this.state.CompanyCurrentValues;
      console.log(CompanyValues);
      if (Object.prototype.hasOwnProperty.call(CompanyValues, 'Name') && CompanyValues['Name'] !== '') {
        this.setState({
          loading: true,
        });

        let Mutations = [
          this.props.CreateCompany({
            variables: this.state.CompanyCurrentValues,
          }),
        ];

        if (this.displayUserForm) {
          Mutations.push(this.props.UpdateUser({
            variables: this.state.UserCurrentValues,
          }));
        }

        Promise.all(Mutations).then(() => {
          this.setState({
            loading: false,
          });
          browserHistory.push('/company/jobs');
        }).catch(err =>
          this.setState({
            error: err.graphQLErrors[0].message || err,
            loading: false,
          })
        );
      } else {
        this.setState({
          error: 'Please enter a Company name',
        });
      }
    }
  }

  displayUserForm () { // Don't bother displaying user form if user is fully signed up
    if (Object.prototype.hasOwnProperty.call(this.props.authedUser, 'User')) {
      if (Object.prototype.hasOwnProperty.call(this.props.authedUser.User, 'email') &&
      Object.prototype.hasOwnProperty.call(this.props.authedUser.User, 'first_name') &&
      Object.prototype.hasOwnProperty.call(this.props.authedUser.User, 'last_name') &&
      !Object.prototype.hasOwnProperty.call(this.props.authedUser, 'freshCreate')) {
        return false;
      }
    }
    return true;
  }

  render () {
    if (this.props.authenticatedID !== null) {
      return (
        <div className='CreateCompany__FromWrapper'>
          {<p style={{ color: 'red' }}>{this.state.error}</p>}
          {
            (this.displayUserForm())
            ? <UpdateUser handleUserChange={this.handleUserChange} {...this.props} />
            : null
          }
          {(this.displayUserForm()) ? <br /> : null}
          <h2 className='FormSegment__title'>Create company</h2>
          <Form onChange={this.handleCompanyChange}>
            <div className='row'>
              <div className='col-md'>
                <input type='text' onKeyDown={this.handleOnKey} placeholder='Company Name' className='Form__Input' name='Name' />
              </div>
            </div>
          </Form>
          <span onClick={this.handleRegister} className='Button__Submit'>
            {(this.state.loading) ? <Spinner className='spinner--white' /> : 'Register'}
          </span>
        </div>
      );
    }
    return null;
  }
}

export default compose(
  graphql(UpdateUserMutation, {
    name: 'UpdateUser'
  }),
  graphql(createCompanyMutation, {
    name: 'CreateCompany'
  })
)(Wrapper);



// WEBPACK FOOTER //
// ./src/routes/company/routes/Create/components/Wrapper/index.js